function PropertiesController(){
	this.className	= "PropertiesController";
	this.glob		= ['/property-management**', '/property-sourcing**', '/settling-in**'];
	this.debug		= false;
};
PropertiesController.inheritsFrom( StandardController );
PropertiesController.prototype.swap = function(onComplete){
	this.$body				= $("body").find(".js-body");
	this.$page 				= this.$body.find(".js-page");

	this.$loadMoreLink 			= this.$page.find('.js-load-more-link');
	this.$loadingMessage 		= this.$page.find('.js-loading-message');
	this.$propertiesContainer 	= this.$page.find('.js-properties');
	this.propertiesPagination = 0;

	this.$loadMoreLink.on('click', Igloo.delegate(this, this.loadMoreProperties));
};

PropertiesController.prototype.on = function(){
}

PropertiesController.prototype.off = function(){
};

PropertiesController.prototype.loadMoreProperties = function() {
	
	this.$loadMoreLink.toggleClass('hide');
	this.$loadingMessage.toggleClass('hide');

	this.propertiesPagination++;
	const newPropertiesPromise = this.ajax({
		propertiesPagination: this.propertiesPagination,
	});

	newPropertiesPromise.then(newProperties => {
		if (newProperties) {

			let $savedProperty = false;

			newProperties.forEach((newProperty, newPropertyIndex) => {
				this.addPropertyToDom(newProperty, newPropertyIndex%3);
				if(newPropertyIndex == 0) $savedProperty = this.$propertiesContainer.find(".property:last-child");
			});

			Aviator.get("baseController").getImageController().$process(this.$propertiesContainer);

			var st = $savedProperty.offset().top - 30;
			$('html, body').animate({
				scrollTop: st
			}, 750);

		} else {
			this.$loadMoreLink.hide();
		}
	})

}
PropertiesController.prototype.ajax = function(data) {
  return $.ajax({
    url: `/${nav.part(0)}/more`,
    data: data,
    method: "post"
  }).then(result => {

    const json = JSON.parse(result);
    const items = json['properties'];

    console.log('items', items)
    
    this.$loadMoreLink.toggleClass('hide');
    this.$loadingMessage.toggleClass('hide');

    if(!json['has_more_properties']) this.$loadMoreLink.hide();
		
    return items;
  })
}
PropertiesController.prototype.addPropertyToDom = function(propertyData, mod) {

	const template = this.getTemplates().property;
	var html = Mustache.render(template.html,propertyData);

	//For image preloading
	html = html.replace(/\<img\ src=/g,"<img src-wait=");

	this.$propertiesContainer.append(html);

}